import { useCallback, useState } from "react";
import { SelectWrapper } from "./SelectWrapper";
import * as Icons from "react-icons/bs";
import { Form } from "react-bootstrap";
import { OptionType } from "../../types";

type NumberStats = { start?: number; end?: number; isRange?: boolean; month?: OptionType };

export type NumberPanelProps = {
  title: string;
  doc_nr: NumberStats;
  doc_year: NumberStats;
  mof_nr: NumberStats;
  mof_year: NumberStats;

  onChange: (data: { doc_nr: NumberStats; doc_year: NumberStats; mof_nr: NumberStats; mof_year: NumberStats }) => void;
};

const NumberRow = ({
  title,
  start,
  end,
  isRange,
  month,
  selectValue,
  selectOptions,
  onChange,
}: NumberStats & {
  title: string;
  selectValue?: OptionType;
  selectOptions?: OptionType[];
  onChange: (data: NumberStats) => void;
}) => {
  return (
    <div className="advanced-search-number-row">
      <div className="advanced-search-number-row-inner">
        <div className="advanced-search-number-title">{title}</div>
        <div className="advanced-search-number-start">
          <Form.Control
            className="form-control"
            type="number"
            value={start ?? ""}
            min={0}
            onChange={(e) => {
              if (!e.target.value.includes("-"))
                onChange({ start: e.target.value ? parseInt(e.target.value, 10) : undefined, end, isRange, month });
            }}
          />
        </div>
        <div className="advanced-search-number-range-toggle" onClick={() => onChange({ start, end, month, isRange: !isRange })}>
          <Icons.BsThreeDots />
        </div>
        {isRange ? (
          <div className="advanced-search-number-end">
            <Form.Control
              className="form-control"
              type="number"
              min={0}
              value={end ?? ""}
              onChange={(e) => {
                if (!e.target.value.includes("-"))
                  onChange({ start, end: e.target.value ? parseInt(e.target.value, 10) : undefined, isRange, month });
              }}
            />
          </div>
        ) : null}
      </div>
      {selectOptions && selectOptions.length ? (
        <div className="advanced-search-number-row-inner last">
          <SelectWrapper
            value={selectValue}
            options={selectOptions}
            onChange={(e) => onChange({ start, end, isRange, month: e || undefined })}
          />
        </div>
      ) : null}
    </div>
  );
};

export const NumberPanel = ({ title, doc_nr, doc_year, mof_nr, mof_year, onChange }: NumberPanelProps) => {
  const [selectedValue, setSelectedValue] = useState<OptionType | undefined>();

  return (
    <div className="advanced-search-panel numbers">
      <div className="advanced-search-panel-title">{title}</div>
      <div className="advanced-search-panel-content">
        <NumberRow title="Nr. Act" onChange={(data) => onChange({ doc_nr: data, doc_year, mof_year, mof_nr })} {...doc_nr} />
        <NumberRow title="An Act" onChange={(data) => onChange({ doc_nr, doc_year: data, mof_year, mof_nr })} {...doc_year} />
        <NumberRow title="MOf Nr" onChange={(data) => onChange({ doc_nr, doc_year, mof_year, mof_nr: data })} {...mof_nr} />
        <NumberRow
          title="MOf An"
          onChange={(data) => onChange({ doc_nr, doc_year, mof_year: data, mof_nr })}
          {...mof_year}
        />
      </div>
    </div>
  );
};
